import { useEffect } from "react";

const SITE_URL = "https://traindriveracademy.com";
const DEFAULT_OG_IMAGE = "/og-image.png";

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// SEO meta + OG/Twitter card + canonical injection.
// Pass `image` to override the default OG image (provide an absolute URL or
// a path beginning with "/").
export default function SEO({ title, description, path, image }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    if (title) {
      setMeta("og:title", title, "property");
      setMeta("twitter:title", title);
    }
    setMeta("og:site_name", "UK Train Driver Academy Ltd", "property");
    setMeta("og:type", "website", "property");
    setMeta("og:locale", "en_GB", "property");
    setMeta("twitter:card", "summary_large_image");

    // Resolve canonical URL. Use the production SITE_URL constant so canonicals
    // always point at the live domain rather than the preview origin.
    const canonicalPath = path || (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonicalUrl = `${SITE_URL}${canonicalPath}`;
    setCanonical(canonicalUrl);
    setMeta("og:url", canonicalUrl, "property");

    // Image
    const ogImage = image || DEFAULT_OG_IMAGE;
    const absImage = ogImage.startsWith("http")
      ? ogImage
      : `${SITE_URL}${ogImage}`;
    setMeta("og:image", absImage, "property");
    setMeta("og:image:width", "1200", "property");
    setMeta("og:image:height", "630", "property");
    setMeta("og:image:alt", title || "UK Train Driver Academy Ltd", "property");
    setMeta("twitter:image", absImage);
  }, [title, description, path, image]);
  return null;
}
